module.exports = {
	"OceanDragon": {
		"title": "쿠키런: 오븐브레이크",
		"description": "링크를 눌러서 레전드 펫과 크리스탈을 받으세요!",
		"gift": "님으로부터 선물이 도착했습니다.",
		"gift_no_name": "신규유저와 복귀유저 모두 크리스탈 선물을 드려요!",
		"download_now": "아직 쿠키런:오븐브레이크를 설치하지 않으셨나요?<br>지금 바로 다운받으세요!",
		"how_to_get_reward": "선물을 받는 방법",
		"install_cro": "쿠키런: 오븐브레이크 설치하기",
		"claim_reward": "선물 받기 버튼 누르기",
		"rewards": "* 선물 : 크리스탈 1천개 + 푸른 회오리용",
		"mission": "<strong>미션!</strong> 떼탈출 에피소드1에서 스테이지1-5까지 달리기!",
		"condition": "선물은 신규/복귀 유저만 받을 수 있습니다.",
		"new_player": "* 신규 유저란? 초대이벤트 기간동안 쿠키런을 처음 시작한 유저입니다.",
		"old_player": "* 복귀 유저란? 쿠키런을 30일 이상 실행하지 않았다가 돌아온 반가운 유저입니다."
	},
	"2ndAnniversary": {
		"title": "쿠키런: 오븐브레이크",
		"description": "링크를 눌러서 레전드 펫과 크리스탈을 받으세요!",
		"gift": "님으로부터 선물이 도착했습니다.",
		"gift_no_name": "신규유저와 복귀유저 모두 크리스탈 선물을 드려요!",
		"download_now": "아직 쿠키런:오븐브레이크를 설치하지 않으셨나요?<br>지금 바로 다운받으세요!",
		"how_to_get_reward": "선물을 받는 방법",
		"install_cro": "쿠키런: 오븐브레이크 설치하기",
		"claim_reward": "선물 받기 버튼 누르기",
		"rewards": "* 선물 : 크리스탈 2,222개 + 푸른 회오리용",
		"mission": "<strong>미션!</strong> 떼탈출 에피소드1에서 스테이지1-5까지 달리기!",
		"condition": "선물은 신규/복귀 유저만 받을 수 있습니다.",
		"new_player": "* 신규 유저란? 초대이벤트 기간동안 쿠키런을 처음 시작한 유저입니다.",
		"old_player": "* 복귀 유저란? 쿠키런을 30일 이상 실행하지 않았다가 돌아온 반가운 유저입니다."
	},
	"MoonLight": {
		"title": "쿠키런: 오븐브레이크",
		"description": "링크를 눌러서 레전드 쿠키와 크리스탈을 받으세요!",
		"gift": "님으로부터 선물이 도착했습니다.",
		"gift_no_name": "신규유저와 복귀유저 모두 크리스탈 선물을 드려요!",
		"download_now": "아직 쿠키런:오븐브레이크를 설치하지 않으셨나요?<br>지금 바로 다운받으세요!",
		"how_to_get_reward": "선물을 받는 방법",
		"install_cro": "쿠키런: 오븐브레이크 설치하기",
		"claim_reward": "선물 받기 버튼 누르기",
		"rewards": "* 선물 : 크리스탈 1천개 + 달빛술사 쿠키",
		"mission": "<strong>미션!</strong> 떼탈출 에피소드1에서 스테이지1-5까지 달리기!",
		"condition": "선물은 신규/복귀 유저만 받을 수 있습니다.",
		"new_player": "* 신규 유저란? 초대이벤트 기간동안 쿠키런을 처음 시작한 유저입니다.",
		"old_player": "* 복귀 유저란? 쿠키런을 30일 이상 실행하지 않았다가 돌아온 반가운 유저입니다."
	},
	"FireSpirit": {
		"title": "쿠키런: 오븐브레이크",
		"description": "링크를 눌러서 레전드 쿠키와 크리스탈을 받으세요!",
		"gift": "님으로부터 선물이 도착했습니다.",
		"gift_no_name": "신규유저와 복귀유저 모두 크리스탈 선물을 드려요!",
		"download_now": "아직 쿠키런:오븐브레이크를 설치하지 않으셨나요?<br>지금 바로 다운받으세요!",
		"how_to_get_reward": "선물을 받는 방법",
		"install_cro": "쿠키런: 오븐브레이크 설치하기",
		"claim_reward": "선물 받기 버튼 누르기",
		"rewards": "* 선물 : 크리스탈 1천개 + 불꽃정령 쿠키",
		"mission": "<strong>미션!</strong> 경기장 입장하기!",
		"condition": "선물은 신규/복귀 유저만 받을 수 있습니다.",
		"new_player": "* 신규 유저란? 초대이벤트 기간동안 쿠키런을 처음 시작한 유저입니다.",
		"old_player": "* 복귀 유저란? 쿠키런을 30일 이상 실행하지 않았다가 돌아온 반가운 유저입니다."
	},
	"RainbowCube": {
		"title": "쿠키런: 오븐브레이크",
		"description": "링크를 눌러 무지개큐브와 크리스탈을 받으세요!",
		"gift": "님으로부터 선물이 도착했습니다.",
		"gift_no_name": "신규유저와 복귀유저 모두 크리스탈 선물을 드려요!",
		"download_now": "아직 쿠키런:오븐브레이크를 설치하지 않으셨나요?<br>지금 바로 다운받으세요!",
		"how_to_get_reward": "선물을 받는 방법",
		"install_cro": "쿠키런: 오븐브레이크 설치하기",
		"claim_reward": "선물 받기 버튼 누르기",
		"rewards": "* 선물 : 크리스탈 3,000개 + 무지개큐브 1,000개",
		"mission": "<strong>미션!</strong> 경기장 입장하기!",
		"condition": "선물은 신규/복귀 유저만 받을 수 있습니다.",
		"new_player": "* 신규 유저란? 초대이벤트 기간동안 쿠키런을 처음 시작한 유저입니다.",
		"old_player": "* 복귀 유저란? 쿠키런을 30일 이상 실행하지 않았다가 돌아온 반가운 유저입니다."
	},
	"JellySkin": {
		"title": "쿠키런: 오븐브레이크",
		"description": "링크를 눌러 무지개큐브와 크리스탈을 받으세요!",
		"gift": "님으로부터 선물이 도착했습니다.",
		"gift_no_name": "신규유저와 복귀유저 모두 크리스탈과 무지개큐브 선물을 드려요!",
		"download_now": "아직 쿠키런:오븐브레이크를 설치하지 않으셨나요?<br>지금 바로 다운받으세요!",
		"how_to_get_reward": "선물을 받는 방법",
		"install_cro": "쿠키런: 오븐브레이크 설치하기",
		"claim_reward": "선물 받기 버튼 누르기",
		"rewards": "* 선물 : 크리스탈 3,000개 + 무지개큐브 1,000개",
		"mission": "<strong>미션!</strong> 경기장 입장하기!",
		"condition": "선물은 신규/복귀 유저만 받을 수 있습니다.",
		"new_player": "* 신규 유저란? 초대이벤트 기간동안 쿠키런을 처음 시작한 유저입니다.",
		"old_player": "* 복귀 유저란? 쿠키런을 30일 이상 실행하지 않았다가 돌아온 반가운 유저입니다."
	},
	"Yeti": {
		"title": "쿠키런: 오븐브레이크",
		"description": "링크를 눌러서 레전드 펫과 크리스탈을 받으세요!",
		"gift": "님으로부터 선물이 도착했습니다.",
		"gift_no_name": "신규유저와 복귀유저 모두 크리스탈과 레전드 펫 선물을 드려요!",
		"download_now": "아직 쿠키런:오븐브레이크를 설치하지 않으셨나요?<br>지금 바로 다운받으세요!",
		"how_to_get_reward": "선물을 받는 방법",
		"install_cro": "쿠키런: 오븐브레이크 설치하기",
		"claim_reward": "선물 받기 버튼 누르기",
		"rewards": "* 선물 : 크리스탈 1,000개 + 눈폭풍 예티",
		"mission": "<strong>미션!</strong> 경기장 입장하기!",
		"condition": "선물은 신규/복귀 유저만 받을 수 있습니다.",
		"new_player": "* 신규 유저란? 초대이벤트 기간동안 쿠키런을 처음 시작한 유저입니다.",
		"old_player": "* 복귀 유저란? 쿠키런을 30일 이상 실행하지 않았다가 돌아온 반가운 유저입니다."
	},
	"DreamCatcher": {
		"title": "쿠키런: 오븐브레이크",
		"description": "링크를 눌러서 레전드 펫과 크리스탈을 받으세요!",
		"gift": "님으로부터 선물이 도착했습니다.",
		"gift_no_name": "신규유저와 복귀유저 모두 크리스탈과 레전드 펫 선물을 드려요!",
		"download_now": "아직 쿠키런:오븐브레이크를 설치하지 않으셨나요?<br>지금 바로 다운받으세요!",
		"how_to_get_reward": "선물을 받는 방법",
		"install_cro": "쿠키런: 오븐브레이크 설치하기",
		"claim_reward": "선물 받기 버튼 누르기",
		"rewards": "* 선물 : 크리스탈 1,000개 + 별빛 드림캐쳐",
		"mission": "<strong>미션!</strong> 경기장 입장하기!",
		"condition": "선물은 신규/복귀 유저만 받을 수 있습니다.",
		"new_player": "* 신규 유저란? 초대이벤트 기간동안 쿠키런을 처음 시작한 유저입니다.",
		"old_player": "* 복귀 유저란? 쿠키런을 30일 이상 실행하지 않았다가 돌아온 반가운 유저입니다."
	},
	"WaveDrop": {
		"title": "쿠키런: 오븐브레이크",
		"description": "링크를 눌러서 레전드 펫과 크리스탈을 받으세요!",
		"gift": "님으로부터 선물이 도착했습니다.",
		"gift_no_name": "신규유저와 복귀유저 모두 크리스탈과 레전드 펫 선물을 드려요!",
		"download_now": "아직 쿠키런:오븐브레이크를 설치하지 않으셨나요?<br>지금 바로 다운받으세요!",
		"how_to_get_reward": "선물을 받는 방법",
		"install_cro": "쿠키런: 오븐브레이크 설치하기",
		"claim_reward": "선물 받기 버튼 누르기",
		"rewards": "* 선물 : 크리스탈 1,000개 + 파도방울",
		"mission": "<strong>미션!</strong> 경기장 입장하기!",
		"condition": "선물은 신규/복귀 유저만 받을 수 있습니다.",
		"new_player": "* 신규 유저란? 초대이벤트 기간동안 쿠키런을 처음 시작한 유저입니다.",
		"old_player": "* 복귀 유저란? 쿠키런을 30일 이상 실행하지 않았다가 돌아온 반가운 유저입니다."
	},
	"JellySkin02": {
		"title": "쿠키런: 오븐브레이크",
		"description": "링크를 눌러 크리스탈과 에일리언 도넛 받으세요!",
		"gift": "님으로부터 선물이 도착했습니다.",
		"gift_no_name": "신규유저와 복귀유저 모두 크리스탈과 에일리언 도넛&펫을 드려요!",
		"download_now": "아직 쿠키런:오븐브레이크를 설치하지 않으셨나요?<br>지금 바로 다운받으세요!",
		"how_to_get_reward": "선물을 받는 방법",
		"install_cro": "쿠키런: 오븐브레이크 설치하기",
		"claim_reward": "선물 받기 버튼 누르기",
		"rewards": "* 선물 : 크리스탈 1,000개 + 에일리언 도넛 & 펫 각 20장",
		"mission": "<strong>미션!</strong> 경기장 입장하기!",
		"condition": "선물은 신규/복귀 유저만 받을 수 있습니다.",
		"new_player": "* 신규 유저란? 초대이벤트 기간동안 쿠키런을 처음 시작한 유저입니다.",
		"old_player": "* 복귀 유저란? 쿠키런을 30일 이상 실행하지 않았다가 돌아온 반가운 유저입니다."
	}
};